var map = {
	"./ashutosh.jpg": 70,
	"./cover.png": 28,
	"./deepak.JPG": 49,
	"./dp.png": 29,
	"./product-icon.png": 36,
	"./rahul.jpg": 71,
	"./sandeep.jpg": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;